let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gWHx9")).then(() => parcelRequire('f2mwF'));